<!-- DEPRECATED: https://app.asana.com/0/1206632156655782/1206988596303354/f  -->

<template>
  <v-container class="blockchain-orders-container">
    <h1>Blockchain Orders</h1>
    <orders-table
      v-if="orders"
      :b-orders="orders"
      :loading="loading"
      :put-b-order="putBOrder"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BlockchainOrdersTable from '@/components/blockchainOrders';

export default {
  name: 'BlockchainOrders',
  components: {
    'orders-table': BlockchainOrdersTable,
  },
  computed: {
    ...mapState({
      loading: state => state.blockchainOrderStore.loading,
      orders: state => state.blockchainOrderStore.bOrders,
    }),
  },
  methods: {
    ...mapActions(['getBOrders', 'putBOrder']),
  },
};
</script>


<style lang="scss" scoped>
.orderDetails {
  padding-left: 16px;
  padding-right: 16px;
}
.orderField {
  padding: 8px;
}
.transactions {
  max-height: 500px;
  overflow-y: auto;
}
.transactionField {
  padding-top: 8px;
}
.toolbar {
  background-color: #1a4c7d;
}
</style>



// WEBPACK FOOTER //
// src/views/blockchainOrders/BlockchainOrders.vue